
<template>
    <div  id='cust_component' class="header fixed-top" :class="this.$store.state.mobile_view ? 'bg-pink white' : 'bg-white'">
        <div class="container-fluid">
            <div class="row">
                <div class="col-11 col-xl-5 col-lg-6 col-sm-10 col-md-7 m-auto p-0">
                    <div class='row'>
                        <div class='col-10 '>
                            <h4 class='store_name_header'> 
                                {{title}}
                            </h4>
                        </div>
                        <div class='col-2'>                                                                                
                            <div class='pull-right'>
                                <div class="dropdown mt-1">

                                    <button class="btn dropdown-toggle pr-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <button  :class="[this.$store.state.mobile_view ? 'btn-dark-pink'  : 'btn-pink', cust_details ? 'p-2' : ''] " class="btn rounded-circle user_icon_height">
                                            <img   v-if='!cust_details' src="../../assets/customer/images/user_icon_white.svg">
                                            <span v-else>{{Fullname}}</span> 
                                        </button>
                                    
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-right " aria-labelledby="dropdownMenuButton">
                                        <div class='home_icon_border point_cursor' @click='redirect_home'
                                         v-if="(store_name && this.path.includes('home')  ? false : store_name ? true : this.path.includes('home') ? true : false)">
                                           <img class='p-3' src="../../assets/customer/images/home_icon.svg" />
                                           <span class='align-middle'>Home</span>
                                        </div>

                                        <div class='home_icon_border point_cursor' @click='redirect_bookings' v-if="cust_details &&  this.path !='/mybookings'">
                                            <img class='p-3' src="../../assets/customer/images/bookings_icon.svg"/>
                                             <span class='align-middle'>Bookings</span>
                                       </div>  
                                         
                                        <div class='point_cursor home_icon_border' @click='redirect_login' v-if="!cust_details  &&  this.path !='/custlogin'">
                                            <img class='p-3' src="../../assets/customer/images/login_icon.svg"/>
                                            <span class='align-middle'>Login</span>
                                        </div>

                                        <div class='point_cursor' @click='redirect_signup' v-if="!cust_details  &&  this.path !='/custsignup'">
                                            <img class="p-3" src="../../assets/customer/images/signup_icon.svg"/>
                                            <span class='align-middle'>Signup</span>
                                        </div>
                                        <div class='point_cursor' @click='redirect_logout' v-if="cust_details">
                                            <img class="p-3" src="../../assets/customer/images/logout_icon.svg"/>
                                            <span class='align-middle'>Logout</span>
                                        </div>  
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .header{
        height: 60px;
        border-bottom: 2px solid #EBEFF2 ;
    }
    .header h4{
        line-height: 56px;
        overflow: hidden;
        height: 60px;
    }

    .home_icon_border{
       border-bottom: 0.5px solid #EBEFF2;
    }
    
    .user_icon_height{
        height: 40px;
        width: 40px;
    }

    .dropdown-toggle::after{
        content: none !important;
        border :0px !important;
        vertical-align: 0 !important;
        margin-left: 10px !important;
    } 

</style>

<script>

    export default {
        name: 'custHeader',
        props:{
            title: String,
        },
        data(){
            return {
                cust_details : false,
                Fullname : '',
                path: '',
                store_name: this.$store.state.store_url_name
            }
        },
        mounted(){

            this.path = window.location.pathname;
            if(this.$session.get('cust_details')){

                this.cust_details = true;

                var  customer_session_details = JSON.parse(this.$session.get('cust_details'))
              
                // Select the first letter of the name
                let Firstname = customer_session_details.cust_first_name.charAt(0).toUpperCase();
        
                // Select the first letter of the lastname
                let lastname = customer_session_details.cust_last_name.charAt(0).toUpperCase();
        
                // Return the initials
                this.Fullname =  Firstname + lastname 
            }
        },
        methods:{
            redirect_login(){
                this.$router.push('/custlogin');
            },
            redirect_home(){
                this.$router.push('/home/'+ this.$store.state.store_url_name)
            },
            redirect_logout()
            {
                this.$session.remove('store_details');
                this.$session.remove("cust_details");
                this.$session.remove('service_obj');
                this.$session.remove('product_obj');
                this.$session.remove('unpaid_booking_details');
                this.$session.remove('cust_banned_data');
                this.$router.push('/custlogin');
            },
            redirect_bookings(){
                this.$router.push('/mybookings');
            },
            redirect_signup(){
                this.$router.push('/custsignup');
            }
        }
    }
</script>